/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.2188 4.8c0-.568.4722-1.0286 1.0546-1.0286.5825 0 1.0547.4605 1.0547 1.0286v3.4286c0 .568-.4722 1.0285-1.0547 1.0285-.5824 0-1.0546-.4605-1.0546-1.0285V4.8Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.2734 0C3.361 0 1 2.3025 1 5.1429V18.857C1 21.6975 3.361 24 6.2734 24c2.9125 0 5.2735-2.3025 5.2735-5.1429V5.1429C11.5469 2.3025 9.1859 0 6.2734 0Zm-3.164 5.1429c0-1.7042 1.4166-3.0858 3.164-3.0858 1.7475 0 3.1641 1.3816 3.1641 3.0858V18.857c0 1.7042-1.4166 3.0858-3.164 3.0858-1.7475 0-3.1641-1.3816-3.1641-3.0858V5.1429Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.2266 14.7429c-.5825 0-1.0547.4605-1.0547 1.0285V19.2c0 .5681.4722 1.0286 1.0547 1.0286.5824 0 1.0546-.4605 1.0546-1.0286v-3.4286c0-.568-.4722-1.0285-1.0546-1.0285Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.2266 24C21.139 24 23.5 21.6975 23.5 18.8571V5.1429C23.5 2.3025 21.139 0 18.2266 0c-2.9125 0-5.2735 2.3025-5.2735 5.1429V18.857c0 2.8404 2.361 5.1429 5.2735 5.1429Zm3.164-5.1429c0 1.7042-1.4166 3.0858-3.164 3.0858-1.7475 0-3.1641-1.3816-3.1641-3.0858V5.1429c0-1.7042 1.4166-3.0858 3.1641-3.0858 1.7474 0 3.164 1.3816 3.164 3.0858V18.857Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuConfiguration'
);
